import initialState from '../../initialState';
import { PreviewPanelActions } from '../../constants';

const reducer = (state = initialState.PreviewPanel, action = {}) => {
  switch (action.type) {
    case PreviewPanelActions.SET_RELOAD:
      return { ...state, reload: action.reload };
    default:
      return state;
  }
};
export default reducer;
